export default __webpack_public_path__ + "static/media/cemetery.d73eb974.jpg";